export const FETCH_AUTO_ASSIGN = "FETCH_AUTO_ASSIGN";
export const FETCH_AUTO_ASSIGN_SUCCESS = "FETCH_AUTO_ASSIGN_SUCCESS";
export const FETCH_AUTO_ASSIGN_ERROR = "FETCH_AUTO_ASSIGN_ERROR";
export const FETCH_AUTO_ASSIGN_TIME = "FETCH_AUTO_ASSIGN_TIME";
export const FETCH_AUTO_ASSIGN_TIME_SUCCESS = "FETCH_AUTO_ASSIGN_TIME_SUCCESS";
export const FETCH_AUTO_ASSIGN_TIME_ERROR = "FETCH_AUTO_ASSIGN_TIME_ERROR";
export const UPDATE_AUTO_ASSIGN = "UPDATE_AUTO_ASSIGN";
export const UPDATE_AUTO_ASSIGN_SUCCESS = "UPDATE_AUTO_ASSIGN_SUCCESS";
export const UPDATE_AUTO_ASSIGN_ERROR = "UPDATE_AUTO_ASSIGN_ERROR";
export const CREATE_AUTO_ASSIGN = "CREATE_AUTO_ASSIGN";
export const CREATE_AUTO_ASSIGN_SUCCESS = "CREATE_AUTO_ASSIGN_SUCCESS";
export const CREATE_AUTO_ASSIGN_ERROR = "CREATE_AUTO_ASSIGN_ERROR";
export const IS_ADDING_UPDATE = "IS_ADDING_UPDATE_STICKER";
export const SET_AUTO_MANAGER_STATE = "SET_AUTO_MANAGER_STATE";

export const UPDATE_AUTO_TIME = "UPDATE_AUTO_TIME";
export const UPDATE_AUTO_TIME_SUCCESS = "UPDATE_AUTO_TIME_SUCCESS";
export const UPDATE_AUTO_TIME_ERROR = "UPDATE_AUTO_TIME_ERROR";

export const UPDATE_AUTO_NOW = "UPDATE_AUTO_NOW";
export const UPDATE_AUTO_NOW_SUCCESS = "UPDATE_AUTO_NOW_SUCCESS";
export const UPDATE_AUTO_NOW_ERROR = "UPDATE_AUTO_NOW_ERROR";
